import { colours } from '../../_styleguide/_colours';
import * as d3 from 'd3';
var ChartStackedArea = /** @class */ (function () {
    function ChartStackedArea(ctrlr) {
        this.ctrlr = ctrlr;
        this.prevArea = false;
    }
    ChartStackedArea.prototype.draw = function (data) {
        this.series = this.ctrlr.svg.layers.data.selectAll(".stackedGroup")
            .data(data)
            .join("g")
            .attr("class", "stackedGroup");
        this.areas = this.series.selectAll(".flow")
            .data(data)
            .join("path")
            .attr('class', 'flow');
    };
    ChartStackedArea.prototype.redraw = function () {
        var _this = this;
        var self = this;
        var newArea = d3.area()
            .x(function (d) { return self.ctrlr.scales.x.scale(new Date(d.data._date)); })
            .y0(function (d) { return self.ctrlr.scales.y.scale(d[0]); })
            .y1(function (d) { return self.ctrlr.scales.y.scale(d[0]); })
            .curve(d3.curveCardinal);
        var area = d3.area()
            .x(function (d) { return self.ctrlr.scales.x.scale(new Date(d.data._date)); })
            .y0(function (d) { return self.ctrlr.scales.y.scale(d[0]); })
            .y1(function (d) { return self.ctrlr.scales.y.scale(d[1]); })
            .curve(d3.curveCardinal);
        this.prevArea = area;
        // new areas
        this.areas
            .attr('d', newArea)
            .transition()
            .delay(200)
            .duration(200)
            .attr('d', area)
            .style('fill', function (d) {
            return colours[_this.ctrlr.mapping.parameters[0].find(function (map) { return map.column === d.key; })['colour']][1];
        })
            .style('stroke', function (d) {
            return colours[_this.ctrlr.mapping.parameters[0].find(function (map) { return map.column === d.key; })['colour']][0];
        });
    };
    return ChartStackedArea;
}());
export default ChartStackedArea;
